import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

interface AnalyticsProviderProps {
  children: React.ReactNode;
  gaId?: string;
  gtmId?: string;
}

export const AnalyticsProvider = ({ 
  children, 
  gaId = '', // Kullanıcı kendi GA4 ID'sini buraya ekleyecek: G-XXXXXXXXXX
  gtmId = '' // Kullanıcı kendi GTM ID'sini buraya ekleyecek: GTM-XXXXXXX
}: AnalyticsProviderProps) => {
  useEffect(() => {
    // GA4 kurulumu
    if (gaId) {
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${gaId}', {
          send_page_view: true,
          cookie_flags: 'SameSite=None;Secure'
        });
      `;
      document.head.appendChild(script2);
    }

    // GTM kurulumu
    if (gtmId) {
      const script = document.createElement('script');
      script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
      `;
      document.head.appendChild(script);

      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.insertBefore(noscript, document.body.firstChild);
    }
  }, [gaId, gtmId]);

  return (
    <>
      <Helmet>
        {/* Google Search Console doğrulama */}
        <meta name="google-site-verification" content="GOOGLE_SEARCH_CONSOLE_VERIFICATION_CODE" />
        
        {/* Bing Webmaster Tools doğrulama */}
        <meta name="msvalidate.01" content="BING_VERIFICATION_CODE" />
      </Helmet>
      {children}
    </>
  );
};
